import * as React from 'react';

import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { DataGrid } from '@process-advisor/process-miner/filters/path/dataGrid';
import { Event } from '@process-advisor/process-miner/api/events';

type Props = {
    type: string;
    attribute: string;
    setApplyEnabled: (value: boolean) => void;
    selectionMode: string
};

export type GridRow = Row & { id: number }

export type Row = {
    activity: string;
};

export const activityGridColumns = () => [
    {
        field: 'activity',
        headerName: 'Activity',
        sortable: true,
        filter: true,
        flex: 3,
        resizable: true,
        wrapText: true,
        autoHeight: true,
        suppressMenu: true,
    }];

export const ActivityGrid: React.FC<Props> = ({
    type,
    attribute,
    setApplyEnabled,
    selectionMode,
}) => {
    const [rows, setRows] = React.useState([]);

    React.useEffect(() => {
        const listener = () => {
            apiProvider.changeIncludeStart({includeStart: true});
            setRows(apiProvider.processActivitiesTable());
        };
        listener();

        apiProvider.on(Event.applyFilter, listener);
        apiProvider.on(Event.resetFilter, listener);

        return () => {
            apiProvider.off(Event.applyFilter, listener);
            apiProvider.off(Event.resetFilter, listener);
        };
    }, []);

    return (
        <DataGrid
            type={type}
            attribute={attribute}
            rows={rows}
            columns={activityGridColumns()}
            setApplyEnabled={setApplyEnabled}
            height="280px"
            selectionMode={selectionMode} />
    );
};
